import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import agent from "../../app/api/agent";
import type { AtdDiagnostics } from "../../app/models/Atd";
import VendorIntegrationCard from "./VendorIntegrationCard";

const AtdIntegrationSettings: React.FC = () => {
    const navigate = useNavigate();
    const [diagnostics, setDiagnostics] = useState<AtdDiagnostics>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();
    const [attempt, setAttempt] = useState(0);
    const accountConnected = Boolean(diagnostics?.profileConfigured && !error);
    useEffect(() => {
        let mounted = true;
        setLoading(true);
        setError(undefined);
        agent.Atd.diagnostics()
            .then((result) => { if (mounted) setDiagnostics(result); })
            .catch(() => {
                if (!mounted) return;
                setDiagnostics(undefined);
                setError("Unable to load ATD connection. Try again.");
            })
            .finally(() => { if (mounted) setLoading(false); });
        return () => { mounted = false; };
    }, [attempt]);

    const openProfile = () => navigate("/integrations/atd/profile");
    const location = diagnostics?.locationNumber ? `Location ${diagnostics.locationNumber} · ` : "";
    return (
        <VendorIntegrationCard
            title="American Tire Distributors"
            status={loading ? "loading" : error ? "error" : accountConnected ? "connected" : "disconnected"}
            action={{
                label: loading ? "Checking…" : error ? "Retry connection check" : accountConnected ? "Manage connection" : "Connect ATD",
                onAction: error ? () => setAttempt(current => current + 1) : openProfile,
            }}
            detail={loading ? undefined : error || (accountConnected ? `${location}${diagnostics?.profileActive ? "Sync is enabled" : "Sync is disabled"}` : undefined)}
        >
            {accountConnected && !loading && <s-button-group>
                <s-button slot="secondary-actions" onClick={() => navigate("/integrations/atd/orders")}>Open orders</s-button>
                <s-button slot="secondary-actions" onClick={() => navigate("/integrations/atd/preview")}>Preview order</s-button>
            </s-button-group>}
        </VendorIntegrationCard>
    );
};
export default AtdIntegrationSettings;
